//@ts-ignore-error
require("es6-promise").polyfill();

import "fetch-ie8";
import 'nodelist-foreach-polyfill';
